import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function PaymentFormRedirection() {
  const navigate = useNavigate();
  const location = useLocation();
  // const params = new URLSearchParams(location.search);
  // const status = params.get("status");

  console.log(location.state);
  // Use a single useEffect to handle setting ApplicationData and redirection
  useEffect(() => {
    const data = location.state?.data;
    const link = location.state?.link;
    const status = location.state?.status;

    if (status === "payment") {
      initiateTransaction(data);
    } else {
      if (link) {
        navigate(link, { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    }
  }, [location.state, navigate]);

  const initiateTransaction = async (response) => {
    console.log("response", response);
    try {
      // Create a form dynamically
      const form = document.createElement("form");
      form.method = "POST";
      // form.action =
      //   "https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction";
      form.action = response.paymentUrl;

      // Add hidden input fields for transaction details
      const encRequest = document.createElement("input");
      encRequest.type = "hidden";
      encRequest.name = "encRequest";
      encRequest.value = response.encRequest;
      form.appendChild(encRequest);

      const accessCode = document.createElement("input");
      accessCode.type = "hidden";
      accessCode.name = "access_code";
      // accessCode.value = "AVTT03KH01CA01TTAC";
      accessCode.value = response.accessCode;
      form.appendChild(accessCode);

      // Optionally, add more input fields with transaction details

      // Submit the form programmatically
      document.body.appendChild(form);
      form.submit();
    } catch (error) {
      // Handle errors here
      console.error("Error initiating transaction:", error);
    }
  };

  return (
    <div>
      <div className="row" style={{ textAlign: "center" }}>
        <div className="col-12">
          <div className="error-template">
            <h1>Wait!</h1>
            <h2>
              Please be patient while your transaction is being processed.
            </h2>
            <div className="error-details">
              {/* Please be patient while your transaction is being processed. */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentFormRedirection;
